import { IRestaurantNode, useGetRecentRestaurantsQuery } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';

export const useGetRecentRestaurants = () => {
  const { isAuthenticated, user } = useAuthContext();
  // Token can exist before GetMe/session finish; the query stays skipped until then,
  // and Apollo reports loading=false for a skipped query.
  const waitingForUser = isAuthenticated && !user?.cognitoId;
  const { data, loading, error } = useGetRecentRestaurantsQuery({
    variables: {
      input: {
        first: 20,
      },
    },
    skip: !isAuthenticated || !user?.cognitoId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    restaurants: (data?.recentRestaurants?.nodes as IRestaurantNode[]) || [],
    loading: loading || waitingForUser,
    error,
  };
};
